import { API_URL } from '../config';

export interface PartnerStats {
  is_partner: boolean;
  codes: {
    code: string;
    discount: number;
    commission: number;
  }[];
  summary: {
    total_students: number;
    pending_commission: number;
    paid_commission: number;
    currency: string;
  };
  history: {
    id: number;
    date: string;
    status: string;
    amount: number;
    user_name: string;
  }[];
}

const getAuthHeader = () => {
  const token = localStorage.getItem('access_token');
  return { Authorization: `Bearer ${token}` };
};

// La barre latérale et l'en-tête demandent toutes deux ce statut à chaque page : une seule
// requête est partagée par jeton pendant DUREE_MS (audit 2026-10-01 : 12 appels par session).
const DUREE_MS = 60_000;
let enCours: { jeton: string | null; quand: number; promesse: Promise<PartnerStats> } | null = null;

export const partnerService = {
  getStats: (): Promise<PartnerStats> => {
    const jeton = localStorage.getItem('access_token');
    if (enCours && enCours.jeton === jeton && Date.now() - enCours.quand < DUREE_MS) {
      return enCours.promesse;
    }
    const promesse = fetch(`${API_URL}/partner/stats`, { headers: getAuthHeader() }).then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch partner stats');
      }
      return response.json() as Promise<PartnerStats>;
    });
    enCours = { jeton, quand: Date.now(), promesse };
    // Un échec ne doit pas rester en mémoire : la prochaine demande réessaie.
    promesse.catch(() => {
      if (enCours?.promesse === promesse) enCours = null;
    });
    return promesse;
  },
};
